"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TvPartnerChannelLocalizedReferenceSchema = void 0;
exports.TvPartnerChannelLocalizedReferenceSchema = {
    "$id": "https://www.redbull.com/schemas/reference/localized/content/tv-partner-channels.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "TvPartnerChannelLocalizedReference",
    "description": "A partner channel lives within the TV space and will allow users to see everything related to a given partner programming (e.g. Padel, WSL).",
    "type": "object",
    "required": [
        "type",
        "id"
    ],
    "properties": {
        "type": {
            "enum": [
                "rrn:content:tv-partner-channels"
            ],
            "type": "string"
        },
        "id": {
            "type": "string",
            "pattern": "^rrn:content:[0-9a-z\\-_]+:[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}:[a-z]{2}-[A-Z]{2,3}$"
        }
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHYtcGFydG5lci1jaGFubmVscy5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9yZWZlcmVuY2UvbG9jYWxpemVkL2NvbnRlbnQvdHYtcGFydG5lci1jaGFubmVscy5zY2hlbWEudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSx3Q0FBd0MsR0FBRztJQUN0RCxLQUFLLEVBQUUsNkZBQTZGO0lBQ3BHLFNBQVMsRUFBRSw4Q0FBOEM7SUFDekQsT0FBTyxFQUFFLG9DQUFvQztJQUM3QyxhQUFhLEVBQUUsOElBQThJO0lBQzdKLE1BQU0sRUFBRSxRQUFRO0lBQ2hCLFVBQVUsRUFBRTtRQUNWLE1BQU07UUFDTixJQUFJO0tBQ0w7SUFDRCxZQUFZLEVBQUU7UUFDWixNQUFNLEVBQUU7WUFDTixNQUFNLEVBQUU7Z0JBQ04saUNBQWlDO2FBQ2xDO1lBQ0QsTUFBTSxFQUFFLFFBQVE7U0FDakI7UUFDRCxJQUFJLEVBQUU7WUFDSixNQUFNLEVBQUUsUUFBUTtZQUNoQixTQUFTLEVBQUUsaUdBQWlHO1NBQzdHO0tBQ0Y7Q0FDRixDQUFBIn0=